module.exports = __webpack_public_path__ + "static/media/loc.c0b939ee.svg";